import { media } from '@morressier/ts';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 120rem;

  ${media.xxsmall`
    padding-left: 1rem;
    padding-right: 1rem;
  `}

  ${media.medium`
    padding-left: 2rem;
    padding-right: 2rem;
  `}
`;

export default Container;
